module.exports = __webpack_public_path__ + "static/media/locked.65783cfd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/locked.svg
// module id = 593
// module chunks = 0